import { CircleX } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ui/button.tsx';

interface RenewalProgramSuccessStepProps {
  onClose: () => void;
}

/**
 * Vue « Félicitations » affichée après la validation du renouvellement.
 */
export const RenewalProgramSuccessStep = ({ onClose }: RenewalProgramSuccessStepProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">{t('form.workspace.renewal.success.title')}</h2>

      <div className="space-y-4 text-muted-foreground">
        <p className="text-sm leading-relaxed">{t('form.workspace.renewal.success.paragraph1')}</p>
        <p className="text-sm leading-relaxed">{t('form.workspace.renewal.success.paragraph2')}</p>
        <p className="text-sm leading-relaxed">{t('form.workspace.renewal.success.paragraph3')}</p>
      </div>

      <div className="flex justify-center pt-4">
        <Button
          type="button"
          onClick={onClose}
          rounded="full"
          className="gap-2 text-white bg-neutral-800 hover:bg-neutral-700"
        >
          <span className="flex justify-center items-center w-5 h-5 rounded-full">
            <CircleX className="w-3 h-3" />
          </span>
          {t('common.close')}
        </Button>
      </div>
    </div>
  );
};
